import {useEffect, useState, useRef} from 'react'
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled, UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space, Upload} from 'antd';
import {getAll, drop, importBulk, importBulkConfirm} from '../../../../apis/SaldosEmpleadoApi';
import {getList as getAllTipoSaldo} from '../../../../apis/TipoSaldoApi';
import Currency from '../../../../components/common/Currency';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Catálogos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Saldos del Empleado</span>
      </>
    ),
}];

const SaldosEmpleado = () => {
    const [items, setItems] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [objectSelected, setobjectSelected] = useState(null);
    const [loading, setLoading] = useState(true);
    const [uploading, setUploading] = useState(false);
    const [tipoSaldos, setTipoSaldos] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
    const columns = [
      {
        title: 'Empleado',
        dataIndex: 'empleado.name',
        key: 'empleado.name',
        sorter: (a, b) => {
          const nameA = a.empleado?.name || '';
          const nameB = b.empleado?.name || '';
          return nameA.localeCompare(nameB);
        },
        render: (item, object)=> {
          return <Space>
            <span>{object.empleado.name}</span>
          </Space>
        }
      },
      {
        title: 'Periodo',
        dataIndex: 'periodo_clave',
        key: 'periodo_clave',
      },
      {
        title: 'Tipo Saldo',
        dataIndex: 'tipo_saldo',
        key: 'tipo_saldo',
        render: (item, object) => {
          const tipoSaldo = tipoSaldos.find(ts => ts.value === object.tipo_saldo_id);
          return tipoSaldo?.displayTitle || object.tipo_saldo_clave || 'N/A';
        }
      },
      {
        title: 'Referencia',
        dataIndex: 'referencia_tipo_saldo',
        key: 'referencia_tipo_saldo',
      },
      {
        title: 'Saldo Actual',
        dataIndex: 'saldo_actual',
        key: 'saldo_actual',
        render: (value, object)=> {
          return <Currency value={value} />
        }
      },
      {
        title: 'Concepto',
        dataIndex: 'concepto_tipo_saldo',
        key: 'concepto_tipo_saldo',
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        render: (item, object)=> {
          return <Space>
          <Button type='primary' size='small' onClick={()=>{
              openDetails(object);
          }}>Editar</Button>
          <Button type='primary' size='small' danger onClick={()=>{
              deleteConfirm(object);
          }}>Eliminar</Button>
        </Space>
        }
      }
    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setobjectSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar la variable?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('¡La variable ha sido eliminada!');
        }
        await refreshData();
    }

    const btnClick = ()=>{
      setOpenEdit(true);
      setobjectSelected(null);
    }

    const onHandlerFinish = async (refresh) => {
      setOpenEdit(false);
      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }

      setLoading(false);
    }

    const handleImport = async (file, _fileList) => {
      const forceSave = false;

      setUploading(true);
      let shouldStopLoading = true;

      try {
        const response = await importBulk(file, forceSave);

        if (response.ok) {
          const result = response.payload;

          if (result.requires_confirmation) {
            shouldStopLoading = false;
            Modal.confirm({
              title: 'Confirmar importación con errores',
              icon: <ExclamationCircleFilled />,
              content: (
                <div>
                  <p>{result.message}</p>
                  <p style={{marginTop: 16}}>Total de registros: {result.total}</p>
                  <p>Registros exitosos: {result.successful}</p>
                  <p>Registros fallidos: {result.failed}</p>
                  {result.errors && result.errors.length > 0 && (
                    <>
                      <p style={{marginTop: 16, fontWeight: 'bold'}}>Errores encontrados:</p>
                      <ul style={{maxHeight: 200, overflow: 'auto', fontSize: '12px'}}>
                        {result.errors.map((error, index) => (
                          <li key={index}>{error}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
              ),
              width: 700,
              okText: 'Sí, guardar registros exitosos',
              cancelText: 'No, cancelar importación',
              onOk: async () => {
                setUploading(true);
                const confirmedResponse = await importBulkConfirm(result.cached_records);

                if (confirmedResponse.ok) {
                  const confirmedResult = confirmedResponse.payload;
                  if (confirmedResult.saved) {
                    message.success(`Se guardaron correctamente ${confirmedResult.successful} saldos`);
                    await refreshData();
                  }
                }
                setUploading(false);
              },
              onCancel: () => {
                message.info('Importación cancelada');
                setUploading(false);
              }
            });
          } else {
            if (result.failed > 0) {
              Modal.warning({
                title: 'Importación completada con errores',
                content: (
                  <div>
                    <p>Total de registros: {result.total}</p>
                    <p>Exitosos: {result.successful}</p>
                    <p>Fallidos: {result.failed}</p>
                    {result.errors && result.errors.length > 0 && (
                      <>
                        <p style={{marginTop: 16, fontWeight: 'bold'}}>Errores:</p>
                        <ul style={{maxHeight: 200, overflow: 'auto'}}>
                          {result.errors.map((error, index) => (
                            <li key={index}>{error}</li>
                          ))}
                        </ul>
                      </>
                    )}
                  </div>
                ),
                width: 600,
              });
            } else {
              message.success(`Se importaron correctamente ${result.successful} saldos`);
            }

            if (result.saved) {
              await refreshData();
            }
          }
        }
      } catch (error) {
        message.error('Error al importar el archivo');
      } finally {
        if (shouldStopLoading) {
          setUploading(false);
        }
      }

      return false;
    };

    const downloadTemplate = () => {
      const csvContent = 'num_empleado,tipo_saldo_clave,tipo_periodo,referencia_tipo_saldo,monto_inicial,descuento,saldo_actual,fecha_inicio,fecha_suspension\n' +
                         '5,CF,SEMANAL,Referencia 1,5000.00,500.00,4500.00,2026-01-01,\n' +
                         '2,CFO,QUINCENAL,Referencia 2,3000.00,200.00,2800.00,2026-01-01,';
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'plantilla_saldos_empleado.csv';
      link.click();
    }

    const loadTipoSaldos = async () => {
      const response = await getAllTipoSaldo();
      if(response.ok){
        setTipoSaldos(response.payload);
      }
    }

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await loadTipoSaldos();
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    return <PageApp 
      routes={routes}
      title={'Saldos de Empleados'} 
      cardTitle='Lista de saldos de empleados'
      extraCard={[
        <Button type="primary" onClick={btnClick}>
          Agregar Saldo
        </Button>
      ]}>
      
      <Space style={{marginTop: 16, marginBottom: 16}}>
        <Upload
          beforeUpload={handleImport}
          accept=".csv,.xlsx,.xls"
          showUploadList={false}
          disabled={uploading}
        >
          <Button 
            icon={<UploadOutlined />} 
            disabled={uploading}
            loading={uploading}
          >
            Importar Saldos
          </Button>
        </Upload>
        <Button 
          icon={<DownloadOutlined />} 
          onClick={downloadTemplate}
        >
          Descargar Plantilla
        </Button>
      </Space>

      <Divider />
      
      {
          loading ? (
            <p>Loading...</p>
          ) : <>
            {
              items.length == 0 ? <Empty />:
              <Table 
                dataSource={items} 
                columns={columns} 
                pagination={{
                  ...pagination,
                  showSizeChanger: true,
                  pageSizeOptions: ['10','20','50','100'],
                  showTotal: (total, range) => `${range[0]}-${range[1]} de ${total}`,
                }}
                onChange={(pag) => setPagination({ current: pag.current, pageSize: pag.pageSize })}
              />
            }
          </>
      }
      {
        (openEdit && objectSelected && objectSelected.id > 0) &&
        <ModalEdit title={"Editar Saldo"} id={objectSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !objectSelected) &&
        <ModalEdit title={"Crear Saldo"} open={openEdit} finish={onHandlerFinish}/>
      }
      
    </PageApp>
}   

export default SaldosEmpleado;
